<template>
  <div class="intro md:h-full flex flex-col justify-center items-center text-center text-brand px-8 md:px-0">
    <div class="mt-auto u-p--oblique max-w-xs text-center" v-html="c.intro.copy" @click="hideIntro()" />
    <div class="mt-auto u-p--small" v-html="c.intro.subline"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import content from '../mixins/content'
import { SECTION_IDS } from '@/util/enums'

export default {
  mixins: [content],
  computed: {
    ...mapState(['activeSectionId'])
  },
  activated () {
    setTimeout(() => {
      this.hideIntro()
    }, 5000)
  },
  methods: {
    hideIntro() {
      if(this.activeSectionId !== SECTION_IDS.INTRO) {
        return
      }
      this.$store.commit('setActiveSectionId', SECTION_IDS.LOGO_WALL)
    }
  },
}
</script>

<style lang="stylus">
.intro
  @media screen and (max-width: 700px)
    height calc(100vh - 300px)
</style>
